import { AdminUserStatus } from '../model/adminUserStatus';
export class AdminUserStatusBuilder {
    static buildAdminUserStatus(data) {
        const adminUserStatus = new AdminUserStatus();
        adminUserStatus.id_user = data.id_user;
        adminUserStatus.agent_status = data.agent_status;
        adminUserStatus.status_timestamp = data.status_timestamp;
        adminUserStatus.position_timestamp = data.position_timestamp;
        adminUserStatus.id_reservation = data.id_reservation;
        adminUserStatus.lat = data.lat;
        adminUserStatus.lng = data.lng;
        adminUserStatus.waiting = data.waiting;
        adminUserStatus.prediction_distance = data.prediction_distance;
        adminUserStatus.prediction_duration = data.prediction_duration;
        adminUserStatus.id_geofence = data.id_geofence;
        adminUserStatus.geofence_in_timestamp = data.geofence_in_timestamp;
        adminUserStatus.multireception = data.multireception;
        adminUserStatus.id_multireception_terminal = data.id_multireception_terminal;
        adminUserStatus.error = data.error;
        adminUserStatus.error_code = data.error_code;
        adminUserStatus.ok = data.ok;
        adminUserStatus.is_queued = data.is_queued;
        adminUserStatus.id = data.id;
        return adminUserStatus;
    }
}
//# sourceMappingURL=adminUserStatus-builder.js.map